import React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { State } from 'store/state';
import {
  developerFilteredProjectsBySectionSelector,
  developerFiltersCountSelector,
  hasDeveloperFilteredProjectsSelector,
  hasOnlyDeveloperProjectSection,
  hasPromotedDeveloperProjectsSelector,
} from 'screens/DeveloperPage/selectors';
import { DeveloperProjectSection, IDeveloperProject } from 'utils/entities';
import { ProjectSection } from 'screens/DeveloperPage/components/projects/ProjectSection';
import { NonPromotedDeveloperProjectSection, genProjectSectionScrollSpy } from 'screens/DeveloperPage/helpers';
import EmptyState from './EmptyState';
import { ScrollSpyTarget } from 'components/scroll-spy';


interface ProjectsProps {
  projectsBySection: Record<NonPromotedDeveloperProjectSection, IDeveloperProject[]>;
  hasProjects: boolean;
  hasFilters: boolean;
  hasPromotedDeveloperProjects?: boolean;
  onlyProjectSection?: boolean;
}

const Projects: React.FC<ProjectsProps> = ({ projectsBySection, hasProjects, hasFilters, hasPromotedDeveloperProjects, onlyProjectSection }) => (
  <>
    {hasProjects ? (
      <>
        {Object.keys(projectsBySection).filter(section => projectsBySection[section] && projectsBySection[section].length).map((section: DeveloperProjectSection, i) => (
          <ScrollSpyTarget targetId={genProjectSectionScrollSpy(section)} key={section}>
            <ProjectSection
              key={section}
              section={section}
              projects={projectsBySection[section]}
              hasFilters={hasFilters}
              isExpanded={!hasPromotedDeveloperProjects && onlyProjectSection && i === 0}
              isFirst={i === 0}
            />
          </ScrollSpyTarget>
        ))}
      </>
    ) : (
      <EmptyState isFiltered />
    )}
  </>
);

const hasFiltersSelector = flow(developerFiltersCountSelector, count => Boolean(count));

const mapStateToProps = (state: State) => ({
  projectsBySection: developerFilteredProjectsBySectionSelector(state),
  hasProjects: hasDeveloperFilteredProjectsSelector(state),
  hasFilters: hasFiltersSelector(state),
  hasPromotedDeveloperProjects: hasPromotedDeveloperProjectsSelector(state),
  onlyProjectSection: hasOnlyDeveloperProjectSection(state),
});

export default connect(mapStateToProps)(Projects);
